import { PencilLine, Search, MessagesSquare, CheckCircle2 } from "lucide-react";

const STEPS = [
  { icon: PencilLine, title: "Tell us what you need", desc: "Describe your project." },
  { icon: Search, title: "We find local pros", desc: "Brivio contacts matching professionals." },
  { icon: MessagesSquare, title: "Compare responses", desc: "Review prices and availability." },
  { icon: CheckCircle2, title: "Choose who you want", desc: "You decide who to contact or hire." },
];

export const HomeHowItWorks = () => (
  <section id="how-brivio-works" className="py-16 md:py-24 bg-[var(--b2-surface)]" data-testid="home-how-it-works">
    <div className="max-w-[1300px] mx-auto px-5 md:px-10">
      <h2 className="font-display text-[32px] md:text-[44px] font-extrabold tracking-tight text-[var(--b2-navy)] text-center mb-12 md:mb-16">How Brivio Works</h2>
      <div className="relative">
        {/* connecting line behind the icons (desktop) */}
        <div className="hidden lg:block absolute top-[60px] left-[12%] right-[12%] h-0.5 bg-gradient-to-r from-[var(--b2-green-border)] via-[var(--b2-green)] to-[var(--b2-green-border)] opacity-50" />
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-x-4 gap-y-10 relative">
          {STEPS.map((s, i) => (
            <div key={s.title} className="text-center px-2 flex flex-col items-center" data-testid={`how-step-${i + 1}`}>
              <div className="relative mb-5">
                <div className="w-[100px] h-[100px] md:w-[120px] md:h-[120px] rounded-full bg-white shadow-[0_16px_40px_rgba(10,21,48,0.10)] text-[var(--b2-green)] flex items-center justify-center">
                  <s.icon className="w-11 h-11 md:w-[52px] md:h-[52px]" strokeWidth={1.7} />
                </div>
                <span className="absolute -top-1 -left-1 w-9 h-9 rounded-full bg-[var(--b2-navy)] text-white text-sm font-display font-extrabold flex items-center justify-center shadow-md">{i + 1}</span>
              </div>
              <p className="font-display text-[17px] md:text-[19px] font-extrabold text-[var(--b2-navy)] leading-snug min-h-[48px] md:min-h-0 flex items-center justify-center">{s.title}</p>
              <p className="text-sm text-[var(--b2-ink-soft)] leading-snug mt-1.5 max-w-[220px]">{s.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  </section>
);
